<template>
  <AppLoadingContainer :predicate="isLoading">
    <div class="card-body">
      <div class="mb-2 text-right">
        <button @click="showAddAttachmentModal" class="btn btn-success d-print-none" :disabled="disableButtons"><i class="fa fa-plus"></i>Add Attachment</button>
      </div>
      <BTable :busy="isLoading" :fields="tableFields" :items="attachments" :responsive="true" primary-key="id" show-empty striped table-class="table-align-middle">
        <template v-slot:cell(actions)="row">
          <div class="btn-group btn-group-sm">
            <button @click="downloadAttachment(row.item.id)" class="btn btn-primary btn-sm d-print-none" :disabled="disableButtons">
              <i class="fas fa-file-download"></i>
            </button>
            <button @click="onDeleteClick(row.item)" class="btn btn-danger btn-sm d-print-none" type="button" :disabled="disableButtons">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </template>
        <template v-slot:cell(createdDate)="row">
          <span>{{ row.item.createdDate | moment('MM/DD/YYYY') }}</span>
        </template>
      </BTable>
    </div>

    <AppModalConfirm :visible="deletingRow" @close="deletingRow=null" @confirm="onDeleteConfirmed(deletingRow)">
      <template v-slot:header>Confirm</template>
      <p v-if="deletingRow">Are you sure you want to delete the attachment?</p>
    </AppModalConfirm>

    <b-modal header-class="bg-maroon text-white" id="add-attachment-modal" ref="addAttachmentModal" title="Add Attachment" @ok="onAddAttachment">
      <b-form @submit.stop.prevent="onAddAttachment">
        <b-form-group label="Attachment">
          <b-form-file
            v-model="newAttachment"
            :state="Boolean(newAttachment)"
            placeholder="Choose a file"
          ></b-form-file>
        </b-form-group>
      </b-form>
      <template v-slot:modal-footer="{ cancel }">
        <button :disabled="isSubmitting" class="btn btn-primary" type="submit" @click="onAddAttachment">Save</button>
        <button @click="cancel" class="btn btn-danger">Close</button>
      </template>
    </b-modal>
    <div class="card-footer d-print-none text-right">
        <RouterLink :to="{ name: 'VISAs' }" class="btn btn-danger"
          >Back</RouterLink
        >
      </div>
  </AppLoadingContainer>
</template>

<script>
import AppLoadingContainer from "@/components/shared/AppLoadingContainer";
import AppModalConfirm from "@/components/shared/AppModalConfirm";
import PersonVisaService from "@/services/PersonVisaService";
import { ToastType } from "@/services/models/shared/ToastType";

export default {
  components: {
    AppLoadingContainer,
    AppModalConfirm,
  },
  data() {
    return {
      attachments: [],
      deletingRow: null,
      isLoading: false,
      newAttachment: null,
      isSubmitting: false,
      disableButtons: false,
      downloadAttachmentId: null,
      tableFields: [
        { key: 'actions', label: '', thStyle: 'width:150px' },
        { key: 'fileName', label: 'File Name' },
        { key: 'createdByPersonName', label: 'Added By' },
        { key: 'createdDate', label: 'Date' },
      ],
    };
  },
  methods: {
    loadData() {
      this.isLoading = true;
      PersonVisaService.getPersonVisaAttachmentList(this.$route.params.id)
        .then((response) => {
          if (response) {
            this.attachments = response;
          } else {
            this.attachments = []; // Set to an empty array if no attachments are found
          }
        })
        .catch(() => {
          this.alert(ToastType.Danger, 'Failed to load attachments');
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    showAddAttachmentModal() {
      this.$refs.addAttachmentModal.show();
    },
    onAddAttachment() {
      this.isSubmitting = true;
      const formData = new FormData();
      if (this.newAttachment !== null) {
        formData.append('submittedByPersonId', this.$store.state.user.id);
        formData.append('file', this.newAttachment);
        PersonVisaService.addPersonVisaAttachment(this.$route.params.id, formData)
          .then(() => {
            this.alert(ToastType.Success, 'The attachment was successfully uploaded');
            this.loadData(); // Reload the attachments
          })
          .catch(() => {
            this.alert(ToastType.Danger, 'Failed to upload attachment');
          })
          .finally(() => {
            this.isSubmitting = false;
            this.$refs.addAttachmentModal.hide();
            this.newAttachment = ''; // Clear the input field after submission
          });
      }
    },
    onDeleteClick(attachment) {
      this.deletingRow = attachment;
    },
    onDeleteConfirmed(deletingRow) {
      PersonVisaService.deletePersonVisaAttachment(deletingRow.id)
        .then(() => {
          this.alert(ToastType.Success, 'The attachment was successfully deleted');
          this.loadData();
        })
        .catch(() => {
          this.alert(ToastType.Danger, 'Failed to delete the attachment');
        })
        .finally(() => {
          this.deletingRow = null;
        });
    },
    downloadAttachment(id) {
      this.disableButtons = true;
      this.downloadAttachmentId = id;
      PersonVisaService.downloadPersonVisaAttachment(id)
        .catch(() => {
          this.alert(ToastType.Danger, "Unable to download attachment")
        })
        .finally(() => {
          this.disableButtons = false,
          this.downloadAttachmentId = null;
        })
    }
  },
  created() {
    this.loadData();
  },
};
</script>
